import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BellRing } from "lucide-react";

export function RosterUnseenNudge() {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["roster-unseen-nudges"],
    queryFn: async () => (await api.get("/roster/unseen-nudges")).data,
    refetchInterval: 60000,
  });
  if (!data || data.length === 0) return null;
  return (
    <div className="flex flex-wrap items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2.5" data-testid="roster-unseen-nudge">
      <BellRing className="mt-0.5 h-4 w-4 text-amber-700" />
      <div className="min-w-0 flex-1 text-sm">
        <span className="font-semibold text-amber-900">{t("Roster change not yet seen")}: </span>
        <span className="text-amber-800">{t("these cleaners haven't opened a roster change that applies today or tomorrow — give them a call.")}</span>
        <ul className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-amber-900">
          {data.map((n) => (
            <li key={n.id} data-testid={`roster-unseen-${n.cleaner_id}`}><b>{n.cleaner_name}</b>: {n.lines.join("; ")}</li>
          ))}
        </ul>
      </div>
      <Link to="/manager/cleaners" className="text-xs font-semibold text-amber-900 underline" data-testid="roster-unseen-link">{t("Open roster")}</Link>
    </div>
  );
}
